import React, { Component } from 'react'

const classNames = require('classnames')

export default class Icon extends Component {
  render() {
    const { icon } = this.props
    return (
        <div
            className={classNames(
                icon, 
                'svg-white me-1'
            )}
            label="logo"
            style={{
                width: '20px',
                height: '20px',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
            }}
        />
    )
  }
}
